<template>
  <div class="number-range">
    <div class="range-row">
      <div class="range-inputs">
        <input type="number" v-model.number="from" placeholder="От" min="0" />
        <span class="dash">—</span>
        <input type="number" v-model.number="to" placeholder="До" min="0" />
        <BaseButton @click="apply" class="apply-btn">Применить</BaseButton>
        <button type="button" class="btn-clear-local" @click="resetLocal">Сброс</button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/ui/BaseButton.vue'
export default {
  name: 'NumberRangeFilter',
  components: { BaseButton },
  props: {
    field: { type: String, required: true },
    initialRange: { type: Array, default: () => [] },
    label: { type: String, default: '' }
  },
  data() {
    return { from: null, to: null }
  },
  watch: {
    initialRange: {
      handler(newVal) {
        if (!Array.isArray(newVal) || newVal.length === 0) {
          this.from = null
          this.to = null
        } else {
          const parse = v => {
            if (v === null || v === undefined || v === '') return null
            const n = Number(String(v).replace(',', '.').replace(/\s+/g,''))
            if (!Number.isFinite(n)) return null
            return n >= 0 ? n : 0 // clamp to minimum 0
          }
          this.from = parse(newVal[0])
          this.to = parse(newVal[1])
        }
      },
      immediate: true
    }
  },
  methods: {
    apply() {
      // нормализуем числа и запрещаем отрицательные (clamp >= 0)
      const clamp = v => (v === null || v === undefined || v === '') ? null : Math.max(0, Number(v))
      const f = clamp(this.from)
      const t = clamp(this.to)

      const isEmpty = (f === null) && (t === null)
      if (isEmpty) {
        this.$emit('filter', { key: this.field, value: [] })
      } else {
        // отправляем числа (пустые значения — пустая строка для совместимости с остальной системой)
        const v = [ f === null ? '' : f, t === null ? '' : t ]
        this.$emit('filter', { key: this.field, value: v })
      }
    },
    resetLocal() {
      this.from = null
      this.to = null
      this.$emit('filter', { key: this.field, value: [] })
    }
  }
}
</script>

<style scoped>
.range-inputs { display:flex; gap:8px; align-items:center; }
.range-inputs input { padding:6px 8px; border-radius:6px; border:1px solid rgba(0,0,0,0.08); width:90px; color:#222222 }
.apply-btn { padding:6px 10px; border-radius:8px; transition: transform .12s ease, box-shadow .12s ease; }
.apply-btn:hover { transform: translateY(-3px); box-shadow: 0 8px 20px rgba(0,0,0,0.12); }
.btn-clear-local {
  background: transparent;
  border: 1px solid rgba(0,0,0,0.08);
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform .12s ease, box-shadow .12s ease;
}
.btn-clear-local:hover { transform: translateY(-3px); box-shadow: 0 8px 20px rgba(0,0,0,0.12); }
.dash { color: rgba(0,0,0,0.45); font-weight:700; padding:0 4px; }
</style>
